import { camelToSnake } from 'utils'

const set_user_properties = (properties) => {
  const camelizedData = camelToSnake(properties)
  const userId = camelizedData?.user_id
  delete camelizedData.user_id
  return {
    ...camelizedData,
    userId,
    user_alo_tier: camelizedData?.user_alo_tier || 'na'
  }
}

export const clear_braze_user = () => {
  braze.requestImmediateDataFlush()
}

export const change_braze_user = (user = {}) => {
  braze.changeUser(camelToSnake(user)?.user_id)
  // setBrazeUserInfo()
  if (braze.isPushSupported()) {
    braze.requestPushPermission()
  }
}

export const sign_up_braze_event = (tier = 'na', existingUser, user) => {
  change_braze_user(user)

  braze.logCustomEvent('sign_up', {
    method: 'email',
    user_alo_tier: tier,
    is_existing_awc_user: existingUser ? 'yes' : 'no',
    ...set_user_properties(user)
  })
}

export const verify_account_braze_event = (
  is_existing_awc_user,
  user_alo_tier = 'na',
  user
) => {
  change_braze_user(user)

  braze.logCustomEvent('account_linked', {
    is_existing_awc_user: is_existing_awc_user ? 'yes' : 'no',
    user_alo_tier,
    ...set_user_properties(user)
  })
}
